import React from 'react';
import './partners_card.scss';
import ArrowRightFill from '../../assets/icons/Arrow_right_fill.svg';

interface PartnersCardProps {
  title: string;
  onClick: any;
  type?: string;
  className?: string;
  hoverText?: string;
  url: string;
  icon?: string;
  pdfLink?: any;
}

const PartnersCard = (props: PartnersCardProps) => {
  const {
    title,
    onClick,
    type,
    className,
    url,
    icon,
    hoverText,
    pdfLink,
  } = props;

  return (
    <div className="resources_card_wrapper">
      <div className="card">
        <div
          className={`${
            type === 'publications' && 'resource_image'
          } resources_card`}
        >
          {type === 'publications'
          && <div className="partners_img_wrapper">
            <img
              src={url}
              alt="resources"
              className={`${type === 'publications' && 'publication_card'}`}
            />
             </div>}
          {type === 'publications' && (
            <div className="wrapper">
              <a href={pdfLink} rel="noreferrer" target="_blank">
                <div className="h6 text" onClick={onClick}>
                  <div className="wrapper_icon">
                    {icon && <img src={icon} alt="" className="icon" />}
                    {hoverText}
                  </div>
                </div>
              </a>
            </div>
          )}
        </div>
        <div className="title_wrapper">
          <div className="title h4">{title}</div>
        </div>
      </div>
    </div>
  );
};

PartnersCard.defaultProps = {
  className: '',
  type: '',
  icon: '',
  hoverText: '',
  pdfLink: '',
};

export default PartnersCard;
